import {ArchivedPersonInsurance, ArchivedProposal, HealthAnswersRevision} from '../archived-proposal';
import {UserInfo} from '../proposal';
import {ExtraRequirementsFile, ExtraRequirementsInquiry} from './extra-requirements-file';
import {MIBFile} from './mib';
import {UnderwritingProfileExtra} from './underwriting-profile-extra';
import {UnderwritingProfileNote} from './underwriting-profile-note';

export type MinifiedUnderwritingProfile = Pick<
  UnderwritingProfile,
  'id' | 'policyNumber' | 'status' | 'underwriterId'
> & {
  extraRequirementsFile?: Pick<ExtraRequirementsFile, 'id' | 'documentNames'> & {
    extraRequirementsInquiries: Pick<ExtraRequirementsInquiry, 'id'>[];
  };
  archivedProposal: Pick<ArchivedProposal, 'id' | 'submittedAt'> & {
    healthAnswersRevisions?: Pick<HealthAnswersRevision, 'id' | 'completedAt'>[];
    insuree: Pick<UserInfo, 'id' | 'firstName' | 'lastName'>;
    protection: {
      personInsurances: Pick<ArchivedPersonInsurance, 'price' | 'coverage'>[];
    };
  };
};

export interface UnderwritingProfile {
  id: string;
  policyNumber: string;
  archivedProposal: ArchivedProposal;
  notes: UnderwritingProfileNote[];
  createdAt: Date;
  status: UnderwritingProfileStatus;
  surchargeRate?: number;
  extraRequirementsFile?: ExtraRequirementsFile;
  mibFile?: MIBFile;
  underwriterId?: string;
  extra?: UnderwritingProfileExtra;
}

export enum UnderwritingProfileStatus {
  ONGOING = 'ONGOING',
  REFUSED = 'REFUSED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
}

export enum DerivedUnderwritingProfileStatus {
  REFUSED = 'REFUSED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  PENDING_CLIENT_ACTION = 'PENDING_CLIENT_ACTION',
  PENDING_UNDERWRITER_ACTION = 'PENDING_UNDERWRITER_ACTION',
  PENDING_EXTERNAL_ACTION = 'PENDING_EXTERNAL_ACTION',
}

export function getDerivedUnderwritingProfileStatus(
  status: UnderwritingProfileStatus,
  healthAnswersRevisions: Pick<HealthAnswersRevision, 'id' | 'completedAt'>[] | undefined,
  extraRequirementsFile?: Pick<ExtraRequirementsFile, 'id' | 'documentNames'> & {
    extraRequirementsInquiries: Pick<ExtraRequirementsInquiry, 'id'>[];
  },
): DerivedUnderwritingProfileStatus {
  if (status === UnderwritingProfileStatus.ONGOING) {
    if (healthAnswersRevisions?.some((r) => !r.completedAt)) {
      return DerivedUnderwritingProfileStatus.PENDING_CLIENT_ACTION;
    }

    if (
      extraRequirementsFile &&
      extraRequirementsFile.extraRequirementsInquiries &&
      extraRequirementsFile.extraRequirementsInquiries.length > 0 &&
      (!extraRequirementsFile.documentNames || extraRequirementsFile.documentNames.length === 0)
    ) {
      return DerivedUnderwritingProfileStatus.PENDING_EXTERNAL_ACTION;
    }

    return DerivedUnderwritingProfileStatus.PENDING_UNDERWRITER_ACTION;
  } else {
    return DerivedUnderwritingProfileStatus[status];
  }
}
